"use client"

import { Link } from "react-router-dom"
import { useForm } from "react-hook-form"
import { useState } from "react"
import { useTranslations } from "../../translations"

const defaultAvatar = "/assets/img/noprofil.png"

const Step2 = ({ defaultValues, next, step }) => {
  const { handleSubmit, watch, setValue } = useForm({
    defaultValues,
  })

  const [required, setRequired] = useState(null)
  const avatar = watch("avatar")
  const { t } = useTranslations()

  const onSubmit = (data) => {
    if (!data.avatar) {
      setRequired(t("profileImageRequired"))
      return
    }
    next(data, step)
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0]
    const reader = new FileReader()
    reader.addEventListener("load", (event) => {
      setValue("avatar", event.target.result)
    })
    reader.readAsDataURL(file)
    setValue("avatar", e.target.result)
    setValue("avatar_file", file)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Link to={"/"}><img src="/assets/img/landing-images/MiABC-33.png" alt="MiABC Logo" className="auth-logo" /></Link>
      <h3 className="title">{t("createAccount")}</h3>
      <label className="upload" htmlFor="camera">
        <img className="user_avt" src={avatar ? avatar : defaultAvatar} width="100" height="100" alt="" />
        <div className="round">
          <input id="camera" type="file" accept="image/*" hidden onChange={handleFileUpload} />
          <i className="fa fa-camera" style={{ color: "#fff" }} />
        </div>
      </label>
      <div className="text-danger mb-2">{required ? required : ""}</div>
      <input type="submit" className="btn" value={t("next")} />
      <Link to="/register/step1" className="btn-2">
        {t("back")}
      </Link>
      <div className="mt-3">
        <Link to="/login" className="text-link-1">
          {t("alreadyHaveAccount")} <strong>{t("signIn")}</strong>
        </Link>
      </div>
      <p className="text-link-1 mt-3">
        {t("privacyRegisterText")}{" "}
        <Link to="/privacy" target="_blank" className="d-inline">
          {t("privacyPolicy")}
        </Link>
      </p>
    </form>
  )
}

export default Step2
